export default function selectize() {
  $('.js-selectize').selectize({
    render: {
      item(item, escape) {
        return `<div>${
          item.value ? `<span class="name">${escape(item.value)
          }</span>` : ''
        }</div>`;
      },
      option(item, escape) {
        const label = item.text;
        const code = item.value ? item.value : null;
        return `${'<div>'
            + '<span class="label">'}${escape(label)}</span>${
          code ? ` (${escape(code)})` : ''
        }</div>`;
      },
    },
    onFocus() {
      const value = this.getValue();
      if (value.length > 0) {
        //this.clear(true);
      }
    },
    onChange(val) {
      const s = this;
      if (s.options[val] && s.options[val].country) {
        $('.flag--input').attr('class', (i, c) => c.replace(/(^|\s)flag-\S+/g, '')).addClass('flag-32').addClass('flag--input')
          .addClass(
            `flag-${s.options[val].country.toLowerCase()}`,
          );
      }
      if (this.$input.hasClass('add-country-validation')) {
        const pattern = this.$input.data('pattern');
        const condition = this.$input.data('cond');
        const dest = this.$input.data('dest');
        const defaultPattern = '[ 0-9]{8,15}';
        if ($(dest)) {
          if (val === condition) {
            $(dest).prop({ pattern });
          } else {
            $(dest).prop({ pattern: defaultPattern });
          }
        }
      }
    },
    onInitialize() {
      const s = this;
      this.revertSettings.$children.each(function () {
        $.extend(s.options[this.value], $(this).data());
      });
      this.trigger('change', this.getValue(), true);
    },
  });
}
